import { GRAYSCALE_700 } from '@styles/colors';
import { INTER } from '@styles/fonts';
import { styled } from 'styled-components';

import homeIcon from '@assets/icons/Home.svg'
import settingsIcon from '@assets/icons/Settings.svg'
import { safeAreaInset } from '@lib/telegram';

export const HomeIcon = styled.img.attrs({src: homeIcon})``

export const SettingsIcon = styled.img.attrs({src: settingsIcon})``

export const TabBarContainer = styled.div`
  width: 100%;
  position: fixed;
  bottom: 0;
  z-index: 1000;
  right: 0;
  height: 5vh;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CircleButtonContainer = styled.div`
  cursor: pointer;
  position: absolute;
  z-index: 1001;

  @media (max-height: 320px) {
    top: -70px;
  }

  @media (min-height: 321px) and (max-height: 420px) {
    top: -70px;
  }
  
  @media (min-height: 421px) and (max-height: 600px) {
    top: -60px;
  }

  @media (min-height: 601px) and (max-height: 700px) {
    top: -70px;
  }
  
  @media (min-height: 701px) and (max-height: 800px) {
    top: -70px;
  }
  
  @media (min-height: 801px) and (max-height: 900px) {
    top: -70px;
  }
  
  @media (min-height: 861px) and (max-height: 900px) {
    top: -70px;
  }
  
  @media (min-height: 901px) and (max-height: 1120px) {
    top: -75px; 
  }
  
  @media (min-height: 1121px) {
    top: -70px;
  }

  @media (min-height: 880px) and (max-height: 1000px) {
    top: -60px;
  }

  @media (min-height: 1100px) and (max-height: 1120px) {
    top: -60px;
  }
  
  @media (min-height: 1121px) {
    top: -60px;
  }
`;

export const GradientCircle = styled.div`
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: linear-gradient(to bottom, #BDE2F5, #595AFE, #9B1BFF);
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: ${INTER.bold};
  font-size: 16px;
  color: white;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
`;

export const BackgroundContainer = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: -100;
  
  /* Small screen (568px height) */
  @media (max-height: 600px) {
    height: 72px;
  }
  
  /* Large screen (896px height) */
  @media (min-height: 601px) and (max-height: 900px) {
    height: 90px;
  }
  
  /* Tablet screen (1112px height) and above */
  @media (min-height: 901px) {
    height: 90px;
  }
`;

export const TabContentArea = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
  height: 100%;
  padding-bottom: 10px;
  padding-left: 20px;
  padding-right: 20px;
  position: relative;
  z-index: 1;
`;

export const TabItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  padding: 0;
  padding-bottom: ${safeAreaInset().bottom*2 || 48}px;
  cursor: pointer;
`;

export const TabLabel = styled.span`
  font-family: ${INTER.regular};
  color: ${GRAYSCALE_700};
  font-size: 11px;
`;

export const InvisibleSpacer = styled.div`
  visibility: hidden;
  width: 30%;
`;
